import React, { useState } from 'react';

import uploadIcon from "../components/images/upload.svg"
import { MDBBtn } from 'mdb-react-ui-kit';
import axios from 'axios';

function UploadMemberImg(props) {

    const [selectedImage, setSelectedImage] = useState(null);
    const [error, setError] = useState("");
    const [closech, setclosech] = useState(false)

    const close = () => {
        setSelectedImage(null);

        setclosech(true)
    }

    // const handleFileChange = async (event) => {
    //     const selectedFile = event.target.files[0];
    //     if (!selectedFile) return;

    //     try {
    //         console.log('Selected file:', selectedFile);
    //         console.log('File size:', selectedFile.size);

    //         const reader = new FileReader();

    //         reader.onload = async (e) => {
    //             const img = new Image();
    //             img.onload = async () => {
    //                 const MAX_DIMENSION = 1080; // 1080x1080 max size
    //                 let width = img.width;
    //                 let height = img.height;

    //                 // File size validation
    //                 // if (selectedFile.size > 10 * 1024 * 1024) {
    //                 //     setError("Please select a file below 10MB.");
    //                 //     return;
    //                 // }

    //                 // 1:1 ratio validation
    //                 // if (width !== height) {
    //                 //     setError("Please upload a square image with a 1:1 aspect ratio.");
    //                 //     return;
    //                 // }

    //                 // Resize if dimensions are larger than allowed
    //                 // if (width > MAX_DIMENSION) {
    //                 //     width = MAX_DIMENSION;
    //                 //     height = MAX_DIMENSION;
    //                 // }

    //                 console.log(width, height, "Adjusted width & height");

    //                 const canvas = document.createElement('canvas');
    //                 const ctx = canvas.getContext('2d');
    //                 canvas.width = width;
    //                 canvas.height = height;
    //                 ctx.drawImage(img, 0, 0, width, height);

    //                 canvas.toBlob(async (blob) => {
    //                     console.log('Converted PNG blob:', blob);
    //                     setSelectedImage(URL.createObjectURL(blob));
    //                     // uploadLogoHandler(blob); // Use blob instead of original file
    //                     uploadLogoHandler(selectedFile); // Or keep this if you don't want to resize
    //                 }, 'image/png');
    //             };
    //             img.src = e.target.result;
    //         };

    //         reader.readAsDataURL(selectedFile);
    //     } catch (error) {
    //         setError('Error processing image.');
    //         console.error('Image processing error:', error);
    //     }
    // };
    // useEffect(() => {
    //     if (file) {
    //         uploadLogoHandler();
    //     }
    // }, [file]);

    const handleFileChange = async (event) => {
        const selectedFile = event.target.files[0];
        if (!selectedFile) return;

        try {
            console.log('Selected file:', selectedFile);
            const reader = new FileReader();

            reader.onload = async (e) => {
                const img = new Image();
                img.onload = async () => {
                    const MAX_DIMENSION = 1080;
                    let { width, height } = img;

                    // Calculate square crop starting from the top
                    const side = Math.min(width, height);
                    const cropX = 0;
                    const cropY = 0; // Always start from top
                    const cropWidth = side;
                    const cropHeight = side;

                    // Output size — shrink to MAX_DIMENSION if larger
                    const outputSize = Math.min(side, MAX_DIMENSION);

                    const canvas = document.createElement('canvas');
                    canvas.width = outputSize;
                    canvas.height = outputSize;
                    const ctx = canvas.getContext('2d');

                    // Draw from top down, cropping the bottom if needed
                    ctx.drawImage(
                        img,
                        cropX,
                        cropY,
                        cropWidth,
                        cropHeight,
                        0,
                        0,
                        outputSize,
                        outputSize
                    );

                    canvas.toBlob(async (blob) => {
                        if (!blob) {
                            setError("Error processing the image.");
                            return;
                        }

                        console.log('Cropped image blob:', blob);
                        setSelectedImage(URL.createObjectURL(blob));

                        // Upload cropped image blob
                        uploadLogoHandler(blob);
                    }, 'image/png');
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(selectedFile);
        } catch (error) {
            setError('Error processing image.');
            console.error('Image processing error:', error);
        }
    };

    const uploadLogoHandler = async (selectedFile) => {

        if (!selectedFile) {
            console.error('No file selected');
            return;
        }
        console.log(selectedFile);
        try {
            const formData = new FormData();
            formData.append('file', selectedFile);
            let response = ""
            let PRIMARY_SERVER_URL = `${window.location.protocol}//${window.location.hostname}/api/`;
            if (PRIMARY_SERVER_URL.includes("localhost")) {
                PRIMARY_SERVER_URL = process.env.REACT_APP_PRIMARY_SERVER_URL
            }
            response = await axios.post(`${PRIMARY_SERVER_URL}waiver/uploadimage/${props.Gid}?name=png`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });


            handleUrl(response.data.url)
            console.log(response.data);
        } catch (error) {
            console.error('Error uploading logo:', error);
        }
    };

    const handleUrl = (data) => {
        props.handleUrl(data)
    }
    let text = "Photo"
    console.log(props.imageurl, 'props.imageurl');

    return (
        <div className="mt-2">
            {/* <div className="d-flex align-items-center justify-content-between">
                <h5 className='m-0'>Upload {text}</h5>

            </div> */}

            {(selectedImage || (closech ? false : props.imageurl)) ? (
                <>
                    <div className="mt-2 mb-2  d-flex align-items-center justify-content-center border rounded-3 p-2 position-relative" onClick={() => close()}>
                        <img src={selectedImage ? selectedImage : props.imageurl} alt="Selected" style={{ maxWidth: '100%' }} />
                    </div>
                    {/* <div className="mt-2 float-end">
                        <MDBBtn onClick={close}>Change {text}</MDBBtn>
                    </div> */}
                    <div>
                        <MDBBtn className='w-100' onClick={close}>Change Your Photo</MDBBtn>
                    </div>
                </>
            ) : (
                <>

                    <div class="mb-1 upload-box">
                        <div class="formbold-mb-5 formbold-file-input">
                            <input type="file" name="file" id="file" onChange={handleFileChange}
                                multiple />
                            <label for="file">
                                <div>
                                    <span className='uplode_icon'><i class="fa-solid fa-arrow-up-from-bracket"></i></span>
                                    <span class="formbold-drop-file mb-3"> Upload Photo here</span>
                                    <span className='browse_btn'>Browse</span>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className='my-2'>
                        <label className='note-text'> <b>Note:</b> Recommended to upload with plain or white background</label>
                    </div>
                    {/* <div className="uploadOuter mt-3 w-100 cursor-pointer">
                        <span className="dragBox2 upload-content cursor-pointer">
                            <span>
                                <img src={uploadIcon} className="upload-img" alt="Upload Icon" />
                            </span>
                            <span>Click here or Drag and Drop to upload {text}.</span>
                            <input
                                type="file"
                                id="uploadFile"
                                className="upload__img LOA cursor-pointer"
                                onChange={handleFileChange}
                                multiple
                            />
                        </span>
                    </div> */}
                    {/* <span className=" upload-content d-block mt-2"><b>Note: </b>Recommended to upload with transparent background</span> */}
                </>
            )}

            {error && <p className="text-danger">{error}</p>}
        </div>
    );
}
export default UploadMemberImg;